import React, { useState } from "react";
import Button from "../Button/Button";
import styles from "./showMoreTooltipData.module.scss";
const ShowMoreTooltipData = ({ data, }) => {
    const [showAll, setShowAll] = useState(false);
    const limitBlocks = 3;
    if (!data)
        return null;
    const allTooltipData = () => {
        const element = [];
        for (const [index, value] of data.entries()) {
            if (!showAll) {
                if (index < limitBlocks) {
                    element.push(React.createElement("div", { key: index, className: styles.item }, value));
                }
            }
            else {
                element.push(React.createElement("div", { key: index, className: styles.item }, value));
            }
        }
        return element;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles["break-text"] },
            allTooltipData(),
            data.length > limitBlocks && !showAll ? (React.createElement(Button, { variant: "text", isInline: true, onClick: () => setShowAll(!showAll), className: styles["show-more"] }, "Show more")) : null)));
};
export default ShowMoreTooltipData;
//# sourceMappingURL=ShowMoreTooltipData.js.map